'use client'

import { useSwiper } from 'swiper/react'
import { useEffect } from 'react'
import { useExposureObserver, useTrackClick } from '../../hooks'
import { TrackerProps } from '@avia/tracker'

export function TrackSwiperNavigation({ config }: TrackerProps) {
  const swiper = useSwiper()

  const click = useTrackClick(config)

  const observe = useExposureObserver(config)

  useEffect(() => {
    const clickPrev = () => {
      click({ attr: { slideType: 'left' } })
    }

    const clickNext = () => {
      click({ attr: { slideType: 'right' } })
    }
    const nextEl = swiper.navigation?.nextEl
    const prevEl = swiper.navigation?.prevEl
    nextEl?.addEventListener('click', clickPrev)
    prevEl?.addEventListener('click', clickNext)

    observe(prevEl, { attr: { slideType: 'left' } })
    observe(nextEl, { attr: { slideType: 'right' } })
    return () => {
      nextEl?.removeEventListener('click', clickPrev)
      prevEl?.removeEventListener('click', clickNext)
    }
  }, [swiper])
  return null
}
